import axios from "axios";
import config from "@/config";
import { getAbcToken } from "@/composables/auth";
import { ensureValidToken } from "@/composables/token-manager";

const AUTH_INFO_KEY = "dressdio-auth-info";
const TOKEN_KEY = "dressdio-auth-token";

// export async function requestToken() {
//     const response = await sendApi('user/login', 'POST');
//
//     if (response.data) {
//         window.localStorage.setItem(AUTH_INFO_KEY, JSON.stringify(response.data));
//         window.localStorage.setItem(TOKEN_KEY, response.data["access_token"]);
//     }
//
//     return response;
// }
//
// export function getToken() {
//     let fullInfo: any = window.localStorage.getItem(AUTH_INFO_KEY);
//     if (fullInfo !== null) {
//         fullInfo = JSON.parse(fullInfo);
//         if (fullInfo.error) {
//             clearLocalStoage();
//         }
//     } else {
//         clearLocalStoage();
//     }
//
//
//     if (fullInfo && fullInfo["access_token"]) {
//         return window.localStorage.getItem(TOKEN_KEY);
//     } else if (fullInfo) {
//         return window.localStorage.getItem(TOKEN_KEY);
//     } else {
//         clearLocalStoage();
//     }
//     return null;
// }

export async function refreshAbcToken(refreshToken: string) {
    try {
        const res = await axios({
            url: `${config.api.fsUri}/api/auth/refresh-token`,
            method: 'POST',
            data: { refreshToken },
        });

        return res;
    } catch (err) {
        console.error('Token refresh error:', err);
        throw err;
    }
}

export async function sendFsApiWithoutToken(route: string, method: string, data?: any, headers?:any): Promise<any> {
    try {
        const res = await axios({
            url: `${config.api.fsUri}/${route}`,
            method: method,
            data: data,
            headers: headers ? headers : {},
            timeout: 60000,
        });

        return res;
    } catch (err) {
        console.error(`API call to ${route} failed:`, err);
        throw err;
    }   
}

export async function sendFsApi(route: string, method: string, data?: any, headers?:any): Promise<any> {
    try {
        // 토큰 유효성 확인 및 자동 갱신
        const token = await ensureValidToken();

        if (!token) {
            throw new Error('No authentication token available');
        }

        // Merge custom headers with default Authorization header
        const requestHeaders = {
            ...headers,
            Authorization: `Bearer ${token}`,
        };

        const res = await axios({
            url: `${config.api.fsUri}/${route}`,
            method,
            data,
            headers: requestHeaders,
            timeout: 60000,
        });

        return res;
    } catch (err: any) {
        console.error(`API call to ${route} failed:`, err);
        
        // 401 Unauthorized 또는 토큰 관련 오류 시 로그인 페이지로 이동
        if (err.response?.status === 401 || err.message === 'No authentication token available') {
            if (typeof window !== 'undefined') {
                window.location.href = '/login';
            }
        }
        
        throw err; // 에러를 다시 throw하여 호출자가 처리할 수 있도록
    }
}

export async function sendApi (route: string, method: string, data?: any, headers?:any){
    return new Promise((resolve, reject) => {
        axios({
            //for prod //for dev
            url: `${config.api.uri}/api/v1/${route}`,
            method: method,
            data: data,
            headers: headers ? headers : {Authorization: `Bearer ${getToken()}`},
        }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        });
    });
}
